var _path, _g, _path2, _path3, _ellipse, _g2, _ellipse2, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoGolf = function SvgLogoGolf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 182 52"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "logo-golf_svg__a",
    width: 30,
    height: 22,
    x: 2,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.973 18.663c-.312.138-1.366.63-1.649.8-4.07 2.369-14.097 14.83-14.112 16.861v.138c.193 1.078 17.039 2.37 21.6.878.311-.108 1.38-.57 1.693-.708 3.565-1.615 5.704-5.23 5.704-9.015 0-1.308-.252-2.631-.787-3.908-1.56-3.677-5.05-5.877-8.69-5.877-1.263 0-2.54.262-3.774.815"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-golf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-golf_svg__b)",
    d: "M31.239 17.847H2.212v21h29.027z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-golf_svg__c",
    width: 24,
    height: 37,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.788 3.63A11.7 11.7 0 0 0 1.441 7.4c-.149.385-.669 1.754-.773 2.154C.208 11.23 0 14.139 0 17.446c0 7.246.936 16.415 2.005 18.693.12.246.223.384.342.461 2.124 1.739 16.355-13.108 19.43-18.185.401-.661.743-1.415 1.04-2.415.401-1.385.61-2.77.61-4.139 0-4.784-2.496-9.107-7.072-11.03A11.2 11.2 0 0 0 12.686 0h-.594c-3.12 0-6.12 1.323-8.29 3.646"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-golf_svg__c)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-golf_svg__d)",
    d: "m9.674-11.958-27.91 34.448L13.74 50.278 41.65 15.83z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-golf_svg__f",
    width: 14,
    height: 24,
    x: 2,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.325,
    cy: 11.82,
    fill: "url(#logo-golf_svg__e)",
    rx: 6.325,
    ry: 11.82,
    transform: "matrix(.95729 .29244 -.27168 .96144 6.244 3.389)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-golf_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D7F5D",
    d: "M14.193 6.46c-3.902 2.896-7.599 14.42-8.96 19.82l2.169 2.978 10.495-10.302z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-golf_svg__h",
    width: 18,
    height: 13,
    x: 11,
    y: 22,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.23,
    cy: 8.978,
    fill: "url(#logo-golf_svg__g)",
    rx: 5.23,
    ry: 8.978,
    transform: "matrix(.4305 .88106 -.89828 .47333 25.594 19.44)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-golf_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D7F5D",
    d: "M28.22 25.86c-3.753-.78-12.197 3.248-15.95 5.36l-.47 2.922 11.494.73z",
    opacity: 0.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#001902",
    fillRule: "evenodd",
    d: "M170.793 14h-3.379v23.563h3.379zm-23.738 13.443c0 6.17-4.315 10.557-10.706 10.557-6.813 0-11.642-5.221-11.642-11.715s4.903-11.715 11.459-11.715c4.15 0 7.675 2.164 9.53 5.354l-3.085 1.842c-1.12-2.089-3.562-3.589-6.427-3.589-4.628 0-7.878 3.513-7.878 8.146s3.177 8.07 8.08 8.07c3.966 0 6.409-2.127 7.051-5.165h-7.308v-3.323h10.926zm-91.652 3.684c0 3.74-2.938 6.455-6.556 6.455h-9.365V14.987h8.686c3.526 0 6.409 2.64 6.409 6.266 0 1.975-.845 3.589-2.222 4.614 1.836 1.006 3.066 2.848 3.066 5.26zm-12.34-12.665v5.943h5.086c1.598 0 2.81-1.291 2.81-2.98s-1.212-2.963-2.81-2.963zm5.784 9.304c1.668 0 2.952 1.4 2.957 3.161-.005 1.78-1.27 3.162-2.957 3.162h-5.784v-6.323zm17.02-6.608v3.76c-2.222-.171-4.811.911-4.811 4.519v8.145h-3.379V21.443h3.379v2.715c.936-2.202 2.846-3 4.811-3m13.83 16.424h3.379v-16.14h-3.38v2.298c-1.193-1.69-3.03-2.715-5.471-2.715-4.242 0-7.768 3.703-7.768 8.487S69.983 38 74.225 38c2.442 0 4.278-1.026 5.472-2.734zm-4.94-13.234c2.81 0 4.94 2.164 4.94 5.164s-2.13 5.165-4.94 5.165-4.94-2.165-4.94-5.165 2.13-5.164 4.94-5.164m25.895-2.905-6.096 16.14h-3.893l-6.097-16.14h3.691l4.37 12.266 4.334-12.266zm8.243-.418c-4.554 0-8.245 3.684-8.245 8.487 0 4.785 3.654 8.488 8.245 8.488s8.245-3.684 8.245-8.488-3.691-8.487-8.245-8.487m0 3.38c2.736 0 4.866 2.164 4.866 5.107s-2.13 5.108-4.866 5.108-4.866-2.164-4.866-5.108 2.13-5.107 4.866-5.107m48.02-3.38c-4.554 0-8.245 3.684-8.245 8.487 0 4.785 3.654 8.488 8.245 8.488s8.245-3.684 8.245-8.488-3.691-8.487-8.245-8.487m.018 3.38c2.736 0 4.866 2.164 4.866 5.107s-2.13 5.108-4.866 5.108-4.866-2.164-4.866-5.108 2.13-5.107 4.866-5.107m21.378-2.962v-.323h-.018c0-2.468 1.322-3.417 3.691-3.19v-3.36c-4.683-.323-7.052 2.183-7.052 6.55v.323h-2.369v3.36h2.369v12.78h3.379v-12.78h3.691v-3.36z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-golf_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 11.8198 -6.32541 0 6.325 11.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo-golf_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 8.9781 -5.23006 0 5.23 8.978)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-golf_svg__b",
    x1: 3.423,
    x2: 32.435,
    y1: 29.098,
    y2: 29.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DB081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#70A77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#397C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81AD7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-golf_svg__d",
    x1: -2.763,
    x2: 21.36,
    y1: 34.816,
    y2: 7.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F815F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#81AD7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84AE80"
  })))));
};
export default SvgLogoGolf;